/**
 * @file: WeWork.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

const kUnavailable = () =>
  Promise.reject('WeWork is unavailable for web build');

export const isAppRegistered = false;

export const isAppInstalled = () => Promise.resolve(false);
export const getAppInstallUrl = kUnavailable;
export const getApiVersion = kUnavailable;
export const openApp = kUnavailable;
export const shareText = kUnavailable;
export const shareImage = kUnavailable;
export const shareVideo = kUnavailable;
export const shareLink = kUnavailable;
export const shareMiniProgram = kUnavailable;
export const registerApp = () => Promise.resolve();
export const unregisterApp = () => Promise.resolve();
